<template>
  <v-container class="pt-0 mt-0">
    <v-row>
      <v-spacer />
      <v-col cols="10">
        <v-form onsubmit="return false">
          <v-card>
            <v-card-title>Password Reset</v-card-title>
            <v-card-text>
              <v-text-field
                v-on:keyup.enter="$refs.passwordcheck.focus()"
                name="password"
                label="New Password"
                v-model="password"
                :type="passwordType"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                outlined
                @click:append="toggleShowPassword()"
              ></v-text-field>
              <v-text-field
                v-on:keyup.enter="resetPassword()"
                name="passwordcheck"
                label="Confirm Password"
                v-model="passwordcheck"
                :type="passwordCheckType"
                :append-icon="showPasswordCheck ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="toggleShowPasswordCheck()"
                outlined
              ></v-text-field>
            </v-card-text>

            <v-alert dismissible close-text="Close Alert" border="left" v-model="showError" elevation="9" type="error">{{
              passwordResetError
            }}</v-alert>
          </v-card>
        </v-form>
      </v-col>
      <v-spacer />
    </v-row>
    <v-row>
      <v-spacer />
      <v-col cols="4">
        <v-card-subtitle class="text-left">
          <v-btn color="primary" to="/sendpasswordresetlink">Send New Link</v-btn>
        </v-card-subtitle>
      </v-col>
      <v-spacer />
      <v-col cols="4">
        <v-card-subtitle class="text-right">
          <v-btn color="success" @click="resetPassword()">Reset Password</v-btn>
        </v-card-subtitle>
      </v-col>
      <v-spacer />
    </v-row>
  </v-container>
</template>

<script>
import serverFunctions from "@/functions/serverFunctions";

export default {
  name: "PasswordReset",
  computed: {
    token() {
      return this.$route.params.token;
    },
    showError() {
      if (this.passwordResetError && this.passwordResetError.length > 0) {
        return true;
      }
      return false;
    },
    passwordResetError() {
      if (!this.password || this.password.length < 8) {
        return "You must enter a password which is at least 8 characters long";
      }
      if (this.password != this.passwordcheck) {
        return "Your New Password and Confirm Passwords do not match";
      }
      return this.passwordResetServerError;
    },
    passwordType() {
      return this.showPassword ? "text" : "password";
    },
    passwordCheckType() {
      return this.showPasswordCheck ? "text" : "password";
    },
  },
  data: () => ({
    showPassword: false,
    showPasswordCheck: false,
    password: "",
    passwordcheck: "",
    resetPasswordResponse: null,
    passwordResetServerError: null,
  }),
  methods: {
    toggleShowPassword() {
      this.showPassword = !this.showPassword;
    },
    toggleShowPasswordCheck() {
      this.showPasswordCheck = !this.showPasswordCheck;
    },
    async resetPassword() {
      if (this.showError) {
        return;
      }

      let token = this.$route.params.token;

      let sendResetPasswordRequest = serverFunctions.getResetPasswordRequest(
        token,
        this.password
      );

      let resetPasswordResponse = await serverFunctions.getPostResponse(
        "/resetPassword",
        sendResetPasswordRequest
      );

      if (!resetPasswordResponse[0].success) {
        this.passwordResetServerError = resetPasswordResponse.failureReason;
      } else {
        this.$router.push("/login");
      }
    },
  },
};
</script>

<style scoped>
.palm-site-green {
  background-color: rgb(176, 217, 173);
}
</style>
